import {Severity, Violation} from '@wix/auto_sdk_ecom_cart-v-2';
import {ComWixEcommerceValidationsSpiV1ViolationSeverity, ViolationFragment} from '../../../../gql/graphql';
import {ViolationTargetModel} from './ViolationTarget.model';

export enum ViolationSeverity {
  error = 'ERROR',
  warning = 'WARNING',
}

export class ViolationModel {
  public severity: ViolationSeverity;
  public description: string;
  public target?: ViolationTargetModel;

  constructor(params: ViolationModel) {
    this.severity = params.severity;
    this.description = params.description;
    this.target = params.target;
  }

  public static fromCheckoutV1(violation?: ViolationFragment) {
    return new ViolationModel({
      severity:
        violation?.severity === ComWixEcommerceValidationsSpiV1ViolationSeverity.ERROR
          ? ViolationSeverity.error
          : ViolationSeverity.warning,
      description: violation?.description ?? '',
      target: ViolationTargetModel.fromCheckoutV1(violation?.target),
    });
  }

  public static fromCartV2(violation: Violation) {
    return new ViolationModel({
      severity:
        violation.severity === Severity.ERROR
          ? ViolationSeverity.error
          : /* istanbul ignore next */ ViolationSeverity.warning,
      description: violation.description ?? /* istanbul ignore next */ '',
      target: ViolationTargetModel.fromCartV2(violation.target),
    });
  }
}
